window.acceleratedDataQueue = window.acceleratedDataQueue || [];
window.acceleratedDataQueue.push({
    'ACC_Metallbude_Cart_12': {
        var: {
            get testWrapper() {
                return document.querySelector('.ACC_Metallbude_Cart_12_wrapper');
            }
        },
        getRecomendations: function () {
            const $this = this;

            // if section is already added, skip
            if ($this.var.testWrapper) return;

            fetch(`${window.Shopify?.routes?.root || "/"}cart.js`)
                .then(r => r.json())
                .then(({ items }) => {
                    const limitedItems = Array.isArray(items) ? items.slice(0, 20) : [];

                    if (!limitedItems.length) return null;

                    const query =
                        limitedItems.reduce(
                            (r, { product_id }) =>
                                r +
                                `product_${product_id}: productRecommendations(productId: "gid://shopify/Product/${product_id}", intent: RELATED) {
                                    title
                                    availableForSale
                                    featuredImage { url(transform: { maxWidth: 200 }) }
                                    handle
                                    variants(first: 5) {
                                        nodes {
                                            availableForSale
                                            id
                                            requiresComponents
                                            title
                                            price {
                                                amount
                                                currencyCode
                                            }
                                            image { url(transform: { maxWidth: 200 }) }
                                            quantityRule { minimum }
                                        }
                                    }
                                }\n`,
                            `query getProductRecommendations() @inContext(language: ${window.Shopify?.locale?.toUpperCase() || "DE"}, country: ${window.Shopify?.country || "DE"}) {\n`
                        ) + "}\n";

                    return fetch(`/api/2025-10/graphql.json`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': document.querySelector(
                                'head meta[name="shopify-checkout-api-token"]'
                            )?.content
                        },
                        body: JSON.stringify({ query })
                    });
                })
                .then(r => {
                    if (!r) return null;
                    return r.json();
                })
                .then((data) => {
                    if (!data) return;

                    const html = $this.buildHtmlBasedOnRecomendations(data);
                    if (!html) return;

                    const cartItems = document.querySelector('cart-items');
                    if (!cartItems) return;
                    // safety : if in mean time, if the wrapper is already inserted, skip
                    if ($this.var.testWrapper) return;

                    cartItems.insertAdjacentHTML('beforeend', html);
                    $this.addToCart();
                })
                .catch(console.error);
        },
        buildHtmlBasedOnRecomendations: function (recommendations) {
            const $this = this;

            if (!recommendations || !recommendations.data) {
                console.warn(`${$this.__testName}: No recommendations data`);
                return '';
            }

            const productGroups = Object.values(recommendations.data); // [[...], [...], ...]
            const products = productGroups.flat().filter(Boolean);     // [...] – all products in one array

            if (!products.length) {
                console.warn(`${$this.__testName}: Empty product list in recommendations`);
                return '';
            }

            const maxProducts = 4;

            const cardsHtml = products
                .slice(0, maxProducts)
                .map((product) => {
                    if (!product || !product.variants || !Array.isArray(product.variants.nodes)) {
                        return '';
                    }

                    // first available variant
                    const variant = product.variants.nodes.find((v) => v && v.availableForSale);
                    if (!variant) return '';

                    const imageUrl =
                        (variant.image && variant.image.url) ||
                        (product.featuredImage && product.featuredImage.url) ||
                        '';

                    const rawAmount = variant.price?.amount ?? '0';
                    const amountNumber = Number(rawAmount);
                    const priceAmount = isNaN(amountNumber) ? rawAmount : amountNumber.toFixed(2);
                    const priceCurrency = variant.price?.currencyCode ?? '';

                    return `
                        <div class="${$this.__testName}_product_card">
                            <a class="${$this.__testName}_product_link" href="/products/${product.handle}">
                                <img src="${imageUrl}" class="${$this.__testName}_product_image" />
                            </a>

                            <div class="${$this.__testName}_right_side">
                                <a class="${$this.__testName}_product_link" href="/products/${product.handle}">
                                    <div class="${$this.__testName}_product_title">${product.title}</div>
                                </a>
                                
                                <div class="${$this.__testName}_product_price">
                                    ${priceAmount} ${priceCurrency}
                                </div>
                                <div class="${$this.__testName}_product_atc_button" data-variant-id="${variant.id}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M2 4.00004H14.6667L12.6667 10.6667H4L2 4.00004ZM2 4.00004L1.5 2.33337M6.66133 7.33337H7.99467M7.99467 7.33337H9.328M7.99467 7.33337V6.00004M7.99467 7.33337V8.66671M7.33333 13C7.33333 13.2653 7.22798 13.5196 7.04044 13.7071C6.8529 13.8947 6.59855 14 6.33333 14C6.06812 14 5.81376 13.8947 5.62623 13.7071C5.43869 13.5196 5.33333 13.2653 5.33333 13M11.3333 13C11.3333 13.2653 11.228 13.5196 11.0404 13.7071C10.8529 13.8947 10.5986 14 10.3333 14C10.0681 14 9.81376 13.8947 9.62623 13.7071C9.43869 13.5196 9.33333 13.2653 9.33333 13" stroke="#FAFAFA" stroke-width="1.01" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Hinzufügen
                                </div>
                            </div>
                        </div>
                    `;
                })
                .filter(Boolean)
                .join('');

            if (!cardsHtml) {
                console.warn(`${$this.__testName}: No valid product cards generated`);
                return '';
            }

            const accSection = `
                <div class="${$this.__testName}_wrapper">
                    <div class="${$this.__testName}_title">Vervollständige Deinen Look:</div>
                    <div class="${$this.__testName}_products_container">
                        ${cardsHtml}
                    </div>
                </div>
            `;

            return accSection;
        },

        addToCart: function () {
            const $this = this;

            $this.runAt(`.${$this.__testName}_product_atc_button`, (buttons) => {
                buttons.forEach(button => {
                    // da ne dodaš listener više puta na isti element
                    if (button.dataset.accBound === 'true') return;
                    button.dataset.accBound = 'true';

                    button.addEventListener('click', (e) => {
                        const vid = e.target.closest(`.${$this.__testName}_product_atc_button`).dataset.variantId.split('/').pop()
                        if (!vid) return;

                        fetch(`/cart/add.js?v=${Date.now()}`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                items: [
                                    { id: vid, quantity: 1 }
                                ]
                            })
                        })
                        .then(r => r.json())
                        .then(cart => {
                            document.dispatchEvent(new CustomEvent('cart:updated', {
                                detail: { cart }
                            }));
                        })
                        .then(() => {
                            document.dispatchEvent(new CustomEvent('cart:refresh', {
                                detail: { open: true }
                            }));
                        })
                        .catch(err => {
                            $this.error(err);
                        });
                    });
                });
            });
        },

        init: function () {
            const $this = this;
            // When <cart-items> exists, insert recommendations (if not already)
            $this.runAt('cart-items', () => {
                if (!$this.var.testWrapper) {
                    $this.getRecomendations();
                }
            });
            // Observe changes in #CartDrawer and re-insert recommendations if needed
            $this.runAt('#CartDrawer', ([target]) => {
                new MutationObserver(
                    $this.throttle(() => {
                        if (!$this.var.testWrapper) {
                            $this.getRecomendations();
                        }
                    }, 200, true)
                ).observe(target, { childList: true, subtree: true });
            });
        }
    }
});
